import React from 'react'

const Todo = ({todo, allTodos, setAllTodos}) => {

    const complete = () => {
        setAllTodos(allTodos.map((item) => {
            if(item.id === todo.id){
                return {
                    ...item,
                    completed: !item.completed
                }
            } else {
                return item;
            }
        }))
    }

    const deleteItem = () => {
        setAllTodos(allTodos.filter((el) => el.id !== todo.id))
    }

    return (
			<div className={`todo-each ${todo.completed? 'completed-todo' : ''}`}>
				<li>{todo.item} </li>
				<div>
					<i onClick={complete} class='fas fa-check'></i>
					<i onClick={deleteItem} class='fas fa-trash'></i>
				</div>
			</div>
		);
}

export default Todo